module.exports = __webpack_public_path__ + "img/ezgif.com-gif-maker-C.e38281c5.png";